module.exports = __webpack_public_path__ + "img/title-3.350ef2e3.png";